import { render, staticRenderFns } from "./fileList.vue?vue&type=template&id=6a2f9807&scoped=true"
import script from "./fileList.vue?vue&type=script&lang=js"
export * from "./fileList.vue?vue&type=script&lang=js"
import style0 from "./fileList.vue?vue&type=style&index=0&id=6a2f9807&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f9807",
  null
  
)

export default component.exports